export default __webpack_public_path__ + "static/media/worksheet-sent.8f873b85.png";